export const DOCUMENT = 'DOCUMENT';
export const DOCUMENT_COUNT = 'DOCUMENT_COUNT';
export const DOCUMENT_BUSY = 'DOCUMENT_BUSY';
